/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  PaginatedSubscriptions,
  Subscription,
  SubscriptionCreateRequest,
  SubscriptionPatchRequest,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PaginatedSubscriptionsFromJSON,
    PaginatedSubscriptionsToJSON,
    SubscriptionFromJSON,
    SubscriptionToJSON,
    SubscriptionCreateRequestFromJSON,
    SubscriptionCreateRequestToJSON,
    SubscriptionPatchRequestFromJSON,
    SubscriptionPatchRequestToJSON,
} from '../models/index';

export interface CreateSubscriptionRequest {
    contentType: CreateSubscriptionContentTypeEnum;
    subscriptionCreateRequest: SubscriptionCreateRequest;
    accept?: CreateSubscriptionAcceptEnum;
    traceparent?: string;
    id?: string;
    source?: boolean;
}

export interface DeleteSubscriptionByIdRequest {
    subscriptionId: string;
    accept?: DeleteSubscriptionByIdAcceptEnum;
    traceparent?: string;
}

export interface GetSubscriptionByIdRequest {
    subscriptionId: string;
    accept?: GetSubscriptionByIdAcceptEnum;
    traceparent?: string;
}

export interface ListSubscriptionsRequest {
    accept?: ListSubscriptionsAcceptEnum;
    traceparent?: string;
    offset?: number;
    limit?: number;
}

export interface PatchSubscriptionByIdRequest {
    contentType: PatchSubscriptionByIdContentTypeEnum;
    subscriptionId: string;
    subscriptionPatchRequest: SubscriptionPatchRequest;
    accept?: PatchSubscriptionByIdAcceptEnum;
    traceparent?: string;
}

/**
 * 
 */
export class SubscriptionsApi extends runtime.BaseAPI {

    /**
     * ## Description  Create a new subscription.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * Create a new subscription.
     */
    async createSubscriptionRaw(requestParameters: CreateSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Subscription>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createSubscription().'
            );
        }

        if (requestParameters['subscriptionCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'subscriptionCreateRequest',
                'Required parameter "subscriptionCreateRequest" was null or undefined when calling createSubscription().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/notifications/subscriptions`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubscriptionCreateRequestToJSON(requestParameters['subscriptionCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionFromJSON(jsonValue));
    }

    /**
     * ## Description  Create a new subscription.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * Create a new subscription.
     */
    async createSubscription(requestParameters: CreateSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Subscription | null | undefined > {
        const response = await this.createSubscriptionRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 201:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  Delete a subscription by `subscriptionId`.  Deleting a subscription will remove all consumers associated with it. Also, all notifications associated with the subscription will be deleted. Also, all related message queues and/or Kafka topics will be deleted. This operation is irreversible.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * Delete a subscription by subscriptionId.
     */
    async deleteSubscriptionByIdRaw(requestParameters: DeleteSubscriptionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError(
                'subscriptionId',
                'Required parameter "subscriptionId" was null or undefined when calling deleteSubscriptionById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/notifications/subscriptions/{subscriptionId}`;
        urlPath = urlPath.replace(`{${"subscriptionId"}}`, encodeURIComponent(String(requestParameters['subscriptionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  Delete a subscription by `subscriptionId`.  Deleting a subscription will remove all consumers associated with it. Also, all notifications associated with the subscription will be deleted. Also, all related message queues and/or Kafka topics will be deleted. This operation is irreversible.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * Delete a subscription by subscriptionId.
     */
    async deleteSubscriptionById(requestParameters: DeleteSubscriptionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSubscriptionByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  Get a subscription by `subscriptionId`.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * Get a subscription by subscriptionId.
     */
    async getSubscriptionByIdRaw(requestParameters: GetSubscriptionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Subscription>> {
        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError(
                'subscriptionId',
                'Required parameter "subscriptionId" was null or undefined when calling getSubscriptionById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/notifications/subscriptions/{subscriptionId}`;
        urlPath = urlPath.replace(`{${"subscriptionId"}}`, encodeURIComponent(String(requestParameters['subscriptionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionFromJSON(jsonValue));
    }

    /**
     * ## Description  Get a subscription by `subscriptionId`.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * Get a subscription by subscriptionId.
     */
    async getSubscriptionById(requestParameters: GetSubscriptionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Subscription> {
        const response = await this.getSubscriptionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  List subscriptions.  Returns a list of subscriptions, ordered by their creation date `createdAt`, from oldest to newest.  Browsing subscriptions must be done in a paginated way, using parameters `limit` and `offset`.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * List subscriptions.
     */
    async listSubscriptionsRaw(requestParameters: ListSubscriptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedSubscriptions>> {
        const queryParameters: any = {};

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/notifications/subscriptions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedSubscriptionsFromJSON(jsonValue));
    }

    /**
     * ## Description  List subscriptions.  Returns a list of subscriptions, ordered by their creation date `createdAt`, from oldest to newest.  Browsing subscriptions must be done in a paginated way, using parameters `limit` and `offset`.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * List subscriptions.
     */
    async listSubscriptions(requestParameters: ListSubscriptionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedSubscriptions> {
        const response = await this.listSubscriptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Patch a subscription by `subscriptionId`.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * Patch a subscription by subscriptionId.
     */
    async patchSubscriptionByIdRaw(requestParameters: PatchSubscriptionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Subscription>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling patchSubscriptionById().'
            );
        }

        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError(
                'subscriptionId',
                'Required parameter "subscriptionId" was null or undefined when calling patchSubscriptionById().'
            );
        }

        if (requestParameters['subscriptionPatchRequest'] == null) {
            throw new runtime.RequiredError(
                'subscriptionPatchRequest',
                'Required parameter "subscriptionPatchRequest" was null or undefined when calling patchSubscriptionById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/notifications/subscriptions/{subscriptionId}`;
        urlPath = urlPath.replace(`{${"subscriptionId"}}`, encodeURIComponent(String(requestParameters['subscriptionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SubscriptionPatchRequestToJSON(requestParameters['subscriptionPatchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionFromJSON(jsonValue));
    }

    /**
     * ## Description  Patch a subscription by `subscriptionId`.  ## Access Control  **AD Entra ID Role**: `BOL.NOTIFICATIONS.SUBSCRIPTIONS.Manage` 
     * Patch a subscription by subscriptionId.
     */
    async patchSubscriptionById(requestParameters: PatchSubscriptionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Subscription> {
        const response = await this.patchSubscriptionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CreateSubscriptionContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateSubscriptionContentTypeEnum = typeof CreateSubscriptionContentTypeEnum[keyof typeof CreateSubscriptionContentTypeEnum];
/**
 * @export
 */
export const CreateSubscriptionAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateSubscriptionAcceptEnum = typeof CreateSubscriptionAcceptEnum[keyof typeof CreateSubscriptionAcceptEnum];
/**
 * @export
 */
export const DeleteSubscriptionByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type DeleteSubscriptionByIdAcceptEnum = typeof DeleteSubscriptionByIdAcceptEnum[keyof typeof DeleteSubscriptionByIdAcceptEnum];
/**
 * @export
 */
export const GetSubscriptionByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetSubscriptionByIdAcceptEnum = typeof GetSubscriptionByIdAcceptEnum[keyof typeof GetSubscriptionByIdAcceptEnum];
/**
 * @export
 */
export const ListSubscriptionsAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type ListSubscriptionsAcceptEnum = typeof ListSubscriptionsAcceptEnum[keyof typeof ListSubscriptionsAcceptEnum];
/**
 * @export
 */
export const PatchSubscriptionByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchSubscriptionByIdContentTypeEnum = typeof PatchSubscriptionByIdContentTypeEnum[keyof typeof PatchSubscriptionByIdContentTypeEnum];
/**
 * @export
 */
export const PatchSubscriptionByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchSubscriptionByIdAcceptEnum = typeof PatchSubscriptionByIdAcceptEnum[keyof typeof PatchSubscriptionByIdAcceptEnum];
